import { render } from "./EditOriginModal.vue?vue&type=template&id=b61053f8"
import script from "./EditOriginModal.vue?vue&type=script&lang=js"
export * from "./EditOriginModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/EditOriginModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b61053f8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b61053f8', __exports__)) {
    api.reload('b61053f8', __exports__)
  }
  
  module.hot.accept("./EditOriginModal.vue?vue&type=template&id=b61053f8", () => {
    api.rerender('b61053f8', render)
  })

}


export default __exports__